import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { OrderHistoryState } from "./types";
import { RootState } from "../types";

const initialState: OrderHistoryState = {};

export const orderHistory: Module<OrderHistoryState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
